import { Injectable, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { OverrideParameterInterceptor } from './core/interceptors/override-parameter.interceptor';
import { PermissionsService } from './user/permissions/permissions.service';

/**
 * Service dedicated to application initialization tasks
 */
@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  private readonly permissionsService: PermissionsService = inject(PermissionsService);
  private readonly OV_PREFIX = "OV_";

  constructor(
    private readonly overrideParameterInterceptor: OverrideParameterInterceptor
  ) {
  }

  /**
   * Initialize the HTTP service based on the current browser URL query params
   * @param currentURL the current URL of the browser
   */
  initializeHttpService(currentURL: string) {
    const overrideParams = this.extractOverrideParameters(currentURL);
    this.permissionsService.initConfig(overrideParams);
    this.overrideParameterInterceptor.initConfig(overrideParams);
  }

  /**
   * Extract override parameters from the current browser URL
   * @param currentUrl the current URL of the browser
   */
  private extractOverrideParameters(currentUrl: string): { [parameterName: string]: string; } {
    const overrideParams: { [parameterName: string]: string; } = { };
    const url = currentUrl;
    if (url.includes("?")) {
      const httpParams = new HttpParams({ fromString: url.split("?")[1] });
      for (const paramName of httpParams.keys()) {
        const paramValue = httpParams.get(paramName);
        if (paramValue && paramName.startsWith(this.OV_PREFIX)) {
          overrideParams[paramName] = paramValue;
        }
      }
    }
    return overrideParams;
  }

}
